<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem label-width="0" v-for="config in selectConfigData" :key="config.id">
          <ElSelect
            v-model="attr[config.valueKey]"
            :multiple="config.multiple"
            :placeholder="config.placeholder"
            collapse-tags
            filterable
            clearable
          >
            <el-option
              v-for="item in dataSource[config.dataKey]"
              :key="item.id"
              :value="item.id"
              :label="item.name"
              style="width: 180px"
            ></el-option>
          </ElSelect>
        </ElFormItem>

        <ElFormItem>
          <DatePick v-model="datetime" @change="search" style="width: 220px"></DatePick>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="search">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/common/js/utils'
import DatePick from '@/components/date-range-picker/index.vue'

export default {
  name: 'TencentCreativeFilter',
  components: { DatePick },
  props: {
    placeholder: {
      type: String
    },
    dataSource: {
      require: true,
      type: Object,
      default: () => {}
    }
  },
  computed: {
    attr() {
      return this
    }
  },
  methods: {
    search() {
      const [queryBeginTime, queryEndTime] = this.datetime || ['', '']
      const params = {
        queryBeginTime,
        queryEndTime,
        adName: this.keyword,
        adAccountId: this.accountId,
        opId: this.opId,
        adStatus: this.status,
        gameId: this.gameId,
        inventoryType: this.inventoryType,
        isAutoRule: this.isAutoRule
      }
      this.$emit('on-search', params)
    }
  },
  data() {
    return {
      datetime: [],
      comDate: [],
      keyword: '',
      accountId: '',
      status: '',
      opId: '',
      gameId: '',
      inventoryType: '',
      isAutoRule: '',
      selectConfigData: [
        {
          id: 1,
          placeholder: '选择计划账号',
          dataKey: 'accountData',
          valueKey: 'accountId'
        },
        {
          id: 2,
          placeholder: '选择计划状态',
          dataKey: 'statusData',
          valueKey: 'status'
        },
        {
          id: 3,
          placeholder: '选择投放人员',
          dataKey: 'opData',
          valueKey: 'opId'
        },
        {
          id: 4,
          placeholder: '选择投放游戏',
          dataKey: 'gameData',
          valueKey: 'gameId'
        },
        // {
        //   id: 5,
        //   placeholder: '选择流量位置',
        //   dataKey: 'inventoryData',
        //   valueKey: 'inventoryType'
        // },
        {
          id: 6,
          placeholder: '有无自动化规则',
          dataKey: 'autoRuleData',
          valueKey: 'isAutoRule'
        }
      ]
    }
  },
  created() {
    const now = formatDate(new Date(), 'yyyy-MM-dd')
    this.datetime = [now, now]
    this.comDate = [now, now]
  }
}
</script>
